import axios from "axios";
import AuthStoreService from "@/helpers/authservice/auth-store-service";
import router from "@/router";
import app from "../main";
import Swal from "sweetalert2";
import UserIcon from "@/assets/images/icons/single_signin_image.svg";
import moment from "moment";
const authStoreService = new AuthStoreService();
const showError = async (message, title = "Error!") => {
  await Swal.fire({
    title: title,
    text: message,
    icon: "error",
    confirmButtonText: "OK",
  });
};
console.log(
  "process.env.VUE_APP_API_BASE_URL",
  process.env.VUE_APP_API_BASE_URL
);
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

const responseCache = {};
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const accessToken = authStoreService.getToken();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    const endpoint = config.url;
    console.log(endpoint);
    if (!responseCache[endpoint]) {
      app.$Progress.start();
      responseCache[endpoint] = {
        isResponsePending: true,
      };
      return config;
    } else if (
      responseCache[endpoint].isResponsePending &&
      endpoint != "api/Notification/list"
    ) {
      return false;
    } else {
      app.$Progress.start();
      responseCache[endpoint].isResponsePending = true;
      return config;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
let hasMultipleSessionPopupOpen = false;
axios.interceptors.response.use(
  async (response) => {
    const endpoint = response.config.url;
    delete responseCache[endpoint];
    if (response?.data?.Status == 2) {
      if (endpoint.includes("refreshtoken")) {
        app.$Progress.finish();
        // await showError(response.data.Errors[0].Content,response.data.Errors[0].Title)
        authStoreService.logOut();
        window.location.href = "/";
      }
      if (response.data.Errors[0]) app.$Progress.finish();
      
      // Skip global error for Onfido generate token to handle inline
      if (!endpoint.includes("api/Onfido/director/generate_sdk_token")) {
          await showError(
            response.data.Errors[0].Content,
            response.data.Errors[0].Title
          );
      }
      return Promise.resolve(response?.data || response);
    } else {
      console.log("axiox", response);
      if (response.status === 200 || response.status === 201) {
        if (response.data?.Body?.NextStep) {
          // let previousSteps = [];
          // let previousStepsString = localStorage.getItem("previousSteps") || null;
          // if (previousStepsString) {
          //     previousSteps = previousStepsString.split(',');
          // }
          // let currentStep = localStorage.getItem('nextStep')
          // if (currentStep) {
          //     previousSteps.push(currentStep)
          //     localStorage.setItem('previousSteps', previousSteps);
          // }
          localStorage.setItem("nextStep", response.data.Body?.NextStep);
        }
        // if (endpoint.includes('refreshtoken') && !response.data.body) {
        //
        // }
        app.$Progress.finish();
        if (response.headers["content-disposition"]) {
          return Promise.resolve(response);
        }
        return Promise.resolve(response.data || response);
      } else {
        app.$Progress.finish();
        console.log(response);
        return Promise.reject(response);
      }
    }
  },
  async (error) => {
    console.log("error", error?.response);
    const endpoint = error?.response?.config?.url;
    if (endpoint && responseCache[endpoint]) {
      responseCache[endpoint].isResponsePending = false;
      delete responseCache[endpoint];
    }

    app.$Progress.fail();
    if (error?.response?.status) {
      if (error.response.config.url.includes("refreshtoken")) {
        authStoreService.logOut();
        window.location.href = "/";
      }
      switch (error.response.status) {
        case 400:
          break;
        case 401:
          if (error.response.config.url.includes("login")) {
            showError(error.response.data.Body.Message);
          } else if (error.response.config.url.includes("refreshToken")) {
            authStoreService.logOut();
            window.location.href = "/";
          } else {
            if (error.response.headers["is-token-expired"]) {
              authStoreService.logOut();
              window.location.href = "/";
              // let accessToken = localStorage.getItem("token") || localStorage.getItem("accessToken")
              // let payload = {
              //     AccessToken: `${accessToken}`,
              //     RefreshToken: 'tst' + localStorage.getItem("refreshToken")
              // }
              // axios.post('api/account/corporate/refreshtoken', payload).then((response) => {
              //     authStoreService.setToken(response.Body.Token);
              //     authStoreService.setRefreshToken(response.Body.RefreshToken);
              // })
            } else {
              if (!hasMultipleSessionPopupOpen) {
                var datetime = moment().format("MMMM D , YYYY [at] hh:mm A");
                hasMultipleSessionPopupOpen = true;
                await Swal.fire({
                  title:
                    "You have two sessions open at the same time. For security reason, this session will be terminated. ",
                  iconHtml: "<img src=" + UserIcon + ">",
                  text: "Logged out on " + datetime,
                  confirmButtonText: "OK",
                }).then((result) => {
                  if (result.isConfirmed) {
                    window.location.href = "/";
                  }
                });
              }
              authStoreService.logOut();
            }
          }

          break;
        case 403:
          router.replace({
            path: "/",
            query: { redirect: router.currentRoute.fullPath },
          });
          break;
        case 404:
          showError("page not exist");
          //console.log('Invalid request')
          break;
        case 500:
          showError("Something went wrong");
          break;
        case 502:
          setTimeout(() => {
            router.replace({
              path: "/",
              query: {
                redirect: router.currentRoute.fullPath,
              },
            });
          }, 1000);
      }
      return Promise.reject(error.message);
    } else {
      console.log("show error");
      //showError(error.message);
    }
  }
);

export default axios;
